import momentJalali from "moment-jalali";
import DatePicker from "react-datepicker2";
import ModalMap from "../ModalMap.js";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ModalReferDocument from "../ModalReferDocument.js";
import { Fragment, useEffect, useRef, useState } from "react";
import ModalReminder from "../../../Components/Modals/ModalReminder";
import { Button, Form, FormGroup, Row, Table } from "react-bootstrap";
import { getCityList, getZoneList } from "../../store/api/LocationAPI";
import ModalNewNotice from "../../../Components/Modals/ModalNewNotice";
import { getCustomerExtAttrSettings } from "../../store/api/SystemSettingsAPI";
import { setMapPop, setPopupMenu, setReferDocPop, setSelectStaffPopup } from "../../store/api/Modals";
import { BookHalf, CalendarDate, CardText, Check2, CheckLg, Command, DashCircle, EmojiAngry, GeoAltFill, List, Pencil, Phone, PlusSquare, ReplyFill, TelephoneOutbound, Trash } from "react-bootstrap-icons";
import { addNewCustomer, addRelatedSection, editCustomerInfo, getCustomerRelatedSections, getLastCustomerCode, deleteRelatedSection, getCustomerByID, setCurrentCustomer } from "../../store/api/CustomerApi";
import { clickToCall, isMobileApp, isWebApp, setErrorDialog } from "../../../store/api/CommonFunctions.js";
import ModalAddNewComplaint from "../ModalAddNewComplaint.js";
import ModalCommands from "../../../Components/Modals/ModalCommands.js";
import ModalSendSMS from "../../../Components/Modals/ModalSendSMS.js";

const CustomerInfo = (props) => {
    const { id } = props;
    const history = useHistory();
    const dispatch = useDispatch();
    const sectionData = useRef({});
    const locationCmbClicked = useRef(false);
    const [mpError, setMPError] = useState({});
    const [isPending, setPending] = useState(false);
    const [sectionError, setSectionError] = useState({});
    const { register, handleSubmit, errors } = useForm();
    const [selectedAgency, selectAgency] = useState(null);
    const [relatedSections, setRelatedSections] = useState([]);
    const [isMainCoChecked, setMainCoChecked] = useState(null);
    const [selectedMiddleman, selectMiddleman] = useState(null);
    const [showAddSection, setShowAddSection] = useState(false);
    const [modalComplaint, setModalComplaint] = useState({ show: false });
    const [popReminder, setPopReminder] = useState({ show: false });
    const [modalNoticeData, setModalNoticeData] = useState({ show: false });
    const [popCommand, setPopCommand] = useState({ show: false });
    const [customer, setCustomerData] = useState(null);
    const [birthDate, setBirthDate] = useState(null);
    const [modalSMS, setModalSMS] = useState({ show: false });
    const { baseInfoes, settings, provinceList, cityList, zoneList, currentLocation, extSettings } = useSelector(state => {
        return {
            baseInfoes: state.customerDataReducer.customerBaseInfoes,
            settings: state.SystemSettingsReducer.systemSettings,
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList,
            zoneList: state.locationDataReducer.zoneList,
            currentLocation: state.locationDataReducer.currentLocation,
            extSettings: state.SystemSettingsReducer.customerExtAttrSettings
        }
    });
    const nationalCodeIsRequired = settings && Array.isArray(settings) && settings.find(s => s.SettingName === "NationalCodeIsRequired")?.SettingValue.toLowerCase() === "true";
    const firstCustomerGroup = baseInfoes?.GroupList && Array.isArray(baseInfoes.GroupList) ? baseInfoes.GroupList[0].ID : "";
    const onProvinceChanged = (provinceID) => {
        locationCmbClicked.current = true;
        dispatch(getCityList(provinceID));
        dispatch(getZoneList());
    }
    const onCityChanged = (cityID) => {
        locationCmbClicked.current = true;
        dispatch(getZoneList(cityID));
    }
    const checkNationalCode = (Name) => {
        if (customer?.Type === 'حقوقی') {
            return true;
        }
        if (Name.length === 10) {
            if (Name === '1111111111' ||
                Name === '0000000000' ||
                Name === '2222222222' ||
                Name === '3333333333' ||
                Name === '4444444444' ||
                Name === '5555555555' ||
                Name === '6666666666' ||
                Name === '7777777777' ||
                Name === '8888888888' ||
                Name === '9999999999') {
                return false;
            }
            let c = parseInt(Name.charAt(9));
            let n = parseInt(Name.charAt(0)) * 10 +
                parseInt(Name.charAt(1)) * 9 +
                parseInt(Name.charAt(2)) * 8 +
                parseInt(Name.charAt(3)) * 7 +
                parseInt(Name.charAt(4)) * 6 +
                parseInt(Name.charAt(5)) * 5 +
                parseInt(Name.charAt(6)) * 4 +
                parseInt(Name.charAt(7)) * 3 +
                parseInt(Name.charAt(8)) * 2;
            let r = n - parseInt(n / 11) * 11;
            if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
                return false;
            }
            else {
                return true;
            }
        }
        else if (Name === '') {
            return !nationalCodeIsRequired;
        }
        else {
            return false;
        }

    }
    const showSelectStaff = () => {
        dispatch(setSelectStaffPopup({ show: true, forAgency: true, forMiddleman: false, onSelect: selectAgency }));
    }
    const showMiddlemanPop = () => {
        dispatch(setSelectStaffPopup({ show: true, forAgency: false, forMiddleman: true, onSelect: selectMiddleman }));
    }
    const onMainChecked = (value) => {
        setMainCoChecked(value);
    }
    const onSubmit = (data) => {
        let er = {};
        if ((!data.Mobile || data.Mobile === "") && (!data.Phone || data.Phone === "")) {
            er.Mobile = "N";
        }
        setMPError(er);
        if (er.Mobile) {
            return;
        }
        data.Latitude = currentLocation?.lat;
        data.Longtitude = currentLocation?.lng;
        data.BirthDate = birthDate;
        if (selectedMiddleman !== null) {
            data.MiddleManCat = selectMiddleman.Cat;
        }
        if (Number(id) > 0) {
            const onSuccess = () => {
                if (currentLocation?.lat?.toString().length > 0) {
                    customer.Latitude = data.Latitude;
                    customer.Longtitude = data.Longtitude;
                }
                setPending(false);
            }
            data.ID = Number(id);
            setPending(true);
            dispatch(editCustomerInfo(data, onSuccess))
        }
        else {
            const onSuccess = (result) => {
                setPending(false);
                history.replace("/CRM/AddEditCustomer/" + result.ID);
                const sendSMS = Array.isArray(settings) && settings.find(s => s.SettingName === "Customer_SendWelcomeSMS")?.SettingValue.toLowerCase() === "true";
                if (sendSMS && data.Mobile?.length > 10) {
                    setModalSMS({
                        show: true,
                        to: data.Mobile,
                        filterData: { ID: result.ID }
                    })
                }
            };
            setPending(true);
            dispatch(addNewCustomer(data, onSuccess));
        }
    }
    function setCustomerType(type) {
        setCustomerData({ ...customer, Type: type });
    }
    const showCommand = () => {
        setPopCommand({
            show: true,
            attachmentType: "customer",
            attachmentID: id
        })
    }
    const showDocRefer = () => {
        dispatch(setReferDocPop({ show: true, documentHardCode: "customer", documentID: id }));
    }
    const showComplaint = () => {
        setModalComplaint({
            show: true,
            CustomerID: customer.ID,
            CustomerName: customer.Name,
            CustomerMobile: customer.Mobile,
            CustomerPhone: customer.Phone
        })
    }
    const showReminerPop = () => {
        setPopReminder({ show: true });
    }
    const showMenu = (e) => {
        const menuItems = [{ icon: <EmojiAngry />, title: "شکایت", onClick: showComplaint },
        { icon: <CalendarDate />, title: "افزودن یادآوری", onClick: showReminerPop },
        { icon: <ReplyFill />, title: "ارجاع به کارتابل کاربر", onClick: showDocRefer },
        { icon: <Command />, title: "دستور کار", onClick: showCommand },
        { icon: <CardText />, title: "صدور اطلاعیه", onClick: showModalNotice }];
        dispatch(setPopupMenu({ title: "سایر عملیات", show: true, top: e.clientY - 100, menuItems: menuItems, left: e.clientX }));
    }
    const addNewSection = () => {
        let er = {};
        if (!sectionData.current.SectionName || sectionData.current.SectionName === "") {
            er.SectionName = "N";
        }
        if (!sectionData.current.SectionResponsible || sectionData.current.SectionResponsible === "") {
            er.Responsible = "N";
        }
        setSectionError(er);
        sectionData.current.SectionItemOrder = (relatedSections?.length ?? 0) + 1
        const onSuccess = (res) => {
            sectionData.current.ID = res.ID;
            const newArr = [...relatedSections, sectionData.current];
            setRelatedSections(newArr);
            sectionData.current = {};
            setShowAddSection(false);
        }
        sectionData.current.CustomerID = id;
        sectionData.current.IsPreCustomer = false;
        dispatch(addRelatedSection(sectionData.current, onSuccess));

    }
    const deleteSection = (secID) => {
        const onSuccess = () => {
            setRelatedSections(relatedSections.filter(s => s.ID !== secID));
        }
        dispatch(deleteRelatedSection(secID, onSuccess));
    }
    function showModalNotice(code) {
        setModalNoticeData({ show: true, customerCode: customer.Code });
    }
    function gotoAccReport() {
        window.open(`/Accounting/ViewAccountsReport/Customers/3/${id}`);
    }
    function call(callNumber) {
        callNumber = callNumber.replace(" ", "");
        if (!callNumber || callNumber === "") {
            return;
        }
        const onCall = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تماس با مشتری");
            }

        }
        clickToCall(callNumber, onCall)
    }
    useEffect(() => {
        if (Number(id) === 0) {
            setCustomerData("PENDING");
            const onGet = (res) => {
                if (!isNaN(res)) {
                    setCustomerData({ Code: res });
                }
            }
            getLastCustomerCode(onGet);
        }
        else {
            const onGet = (res) => {
                setCustomerData("PENDING");
                if (res?.Error) {
                    setErrorDialog(dispatch, res.Error, "دریافت اطلاعات طرف حساب");
                }
                else if (res?.ID) {
                    setCustomerData(res);
                    setBirthDate(res?.BirthDate);
                    //برای تب خدمات استفاده میشود
                    dispatch(setCurrentCustomer({ Phone: res.Phone, Mobile: res.Mobile, Name: res.Name, Address: res.Address }));
                    if (Number(res.ProvinceID) > 0) {
                        dispatch(getCityList(res.ProvinceID));
                    }
                    if (Number(res.CityID) > 0) {
                        dispatch(getZoneList(res.CityID));
                    }
                }
            }
            getCustomerByID(id, onGet);
            getCustomerRelatedSections(id, false, setRelatedSections);
        }
        dispatch(getCustomerExtAttrSettings());
    }, [id]);
    return (
        <Fragment>
            {Number(id) > 0 ?
                <Fragment>
                    <ModalReferDocument />
                    <ModalNewNotice popData={modalNoticeData} setPopData={setModalNoticeData} />
                    <ModalReminder attachmentID={id} attachmentType="customer" pop={popReminder} setPop={setPopReminder} />
                    <ModalAddNewComplaint popData={modalComplaint} setPopData={setModalComplaint} />
                    <ModalCommands popData={popCommand} setPopData={setPopCommand} />
                </Fragment> :
                null

            }
            <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} templateType="customers" sendFromModel="customer" />
            <ModalMap location={{ lat: !customer || !customer.Latitude || Number(customer.Latitude) === 0 ? 35.6996 : customer.Latitude, lng: !customer || !customer.Longtitude || Number(customer.Longtitude) === 0 ? 51.3380 : customer.Longtitude, zoom: 9 }} />
            <input type="hidden" value={id} />
            {(!customer || customer === "PENDING") &&
                <div style={{ textAlign: "center" }}>
                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                </div>}
            {customer?.Code &&
                <form onSubmit={handleSubmit(onSubmit)} readOnly>
                    <Row className="rowBorder mt-3">
                        <div className="rowTitle">اطلاعات اولیه</div>
                        <div className="form-group col-md-1" >
                            <label>نوع مشتری</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            <select className="form-control" name="Type" ref={register({ required: true })}
                                defaultValue={customer?.Type ?? "مرد"} onChange={e => setCustomerType(e.target.value)}>
                                <option key={-1} value=''>انتخاب کنید</option>
                                <option key={0} value='حقوقی'>حقوقی </option>
                                <option key={1} value='مرد'>مرد</option>
                                <option key={2} value='زن'>زن </option>
                            </select>
                            {errors.Type && <small className="errors"> انتخاب نوع مشتری الزامی است</small>}
                        </div>
                        {customer?.Type !== "حقوقی" &&
                            <div className="form-group col-md-1" >
                                <label>نام </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <input type="text" className="form-control" name="FirstName" ref={register({})}
                                    defaultValue={customer?.FirstName ?? ""} />
                            </div>
                        }
                        <div className="form-group col-md-2" >
                            <label>{customer?.Type === "حقوقی" ? "نام" : "نام خانوادگی"}</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            <input type="text" className="form-control" name="Name" ref={register({ required: true })}
                                defaultValue={customer?.Name ?? ""} />
                            {errors.Name && <small className="errors"> نام را وارد کنید </small>}
                        </div>
                        <div className="form-group col-md-2" >
                            <label>{customer?.Type === 'حقوقی' && 'شناسه ملی'}{customer?.Type !== 'حقوقی' && 'کد ملی'}</label>{nationalCodeIsRequired && <span style={{ color: "red" }}>*</span>}
                            <input type="text" className="form-control" name="NationalCode" ref={register({ validate: checkNationalCode })}
                                defaultValue={customer?.NationalCode ?? ""} />
                            {errors.NationalCode && <small className="errors"> کد ملی را وارد نشده است/معتبر نیست </small>}
                        </div>
                        <div className="form-group col-md-1" >
                            <label>کد حساب</label>
                            <input type="text" className="form-control" name="Code" readOnly
                                value={customer?.Code ?? ""} />
                        </div>
                        <div className="form-group col-md-2" >
                            <label>گروهبندی</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.GroupList && Array.isArray(baseInfoes.GroupList) &&
                                <select className="form-control" name="CustomerGroupID" ref={register({ required: true })}
                                    defaultValue={customer?.CustomerGroupID ?? firstCustomerGroup}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.GroupList.map((item, i) => <option key={i} value={item.ID}>{item.Group}</option>)}
                                </select>
                            }
                            {errors.CustomerGroupID && <small className="errors"> انتخاب گروهبندی الزامی است</small>}
                        </div>
                        <div className="form-group col-md-1" >
                            <label>ماهیت حساب</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            <select className="form-control" name="CustomerAccountType" ref={register({ required: true })}
                                defaultValue={customer?.CustomerAccountType ?? "بدهکار"}>
                                <option value="">انتخاب کنید</option>
                                <option value={true}>بدهکار </option>
                                <option value={false}>بستانکار </option>
                            </select>
                            {errors.CustomerAccountType && <small className="errors"> انتخاب ماهیت مشتری الزامی است</small>}
                        </div>
                        <div className="form-group col-md-2" >
                            <label>کد اقتصادی</label>
                            <input type="text" className="form-control" name="ComercialCode" ref={register({})}
                                defaultValue={customer?.ComercialCode ?? ""} />
                        </div>
                        <div className="form-group col-md-2" >
                            <label>کد اشتراک</label>
                            <input type="text" className="form-control" name="SubscriptionCode" ref={register({})}
                                defaultValue={customer?.SubscriptionCode ?? ""} />
                        </div>
                        <div className="form-group col-md-2" >
                            <label>کد گذرنامه</label>
                            <input type="text" className="form-control" name="PasportCode" ref={register({})}
                                defaultValue={customer?.PasportCode ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <label>عنوان احترام</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.RespectTitleList && Array.isArray(baseInfoes.RespectTitleList) &&
                                <select className="form-control" name="RespectTitle" ref={register({})}
                                    defaultValue={customer?.RespectTitle ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.RespectTitleList.map((item, i) => <option key={i} value={item.InfoName}>{item.InfoName}</option>)}
                                </select>
                            }
                        </div>
                    </Row>
                    <Row className="rowBorder mt-3">
                        <div className="rowTitle">اطلاعات تماس</div>
                        <div className="form-group col-md-2" >
                            <label>تلفن</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            <input type="text" className="form-control" name="Phone" ref={register({})}
                                defaultValue={customer?.Phone ?? ""} />
                            {mpError.Mobile && <small className="errors"> تلفن/موبایل مشتری را وارد کنید</small>}
                            {Number(customer?.ID) > 0 && customer.Phone?.length > 3 &&
                                <Button className="btn-input-tiny" onClick={() => call(customer.Phone)}><TelephoneOutbound size={22} /></Button>
                            }
                        </div>
                        <div className="form-group col-md-2" >
                            <label>موبایل</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            <input type="text" className="form-control" name="Mobile" ref={register({})}
                                defaultValue={customer?.Mobile ?? ""} />
                            {Number(customer?.ID) > 0 && customer.Mobile?.length > 9 &&
                                <Button className="btn-input-tiny" onClick={() => call(customer.Mobile)}><TelephoneOutbound size={22} /></Button>
                            }                                
                            {mpError.Mobile && <small className="errors"> تلفن/موبایل مشتری را وارد کنید</small>}
                        </div>
                        <div className="form-group col-md-2" >
                            <label>دورنگار</label>
                            <input type="text" className="form-control" name="Fax" ref={register({})}
                                defaultValue={customer?.Fax ?? ""} />
                        </div>
                        <div className="form-group col-md-2" >
                            <label>Email</label>
                            <input type="text" className="form-control" name="Email" ref={register({})}
                                defaultValue={customer?.Email ?? ""} />
                        </div>
                        <div className="form-group col-md-2" >
                            <label>استان</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            {provinceList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {provinceList && Array.isArray(provinceList) &&
                                <select className="form-control" name="ProvinceID" ref={register({ required: true })}
                                    defaultValue={customer?.ProvinceID ?? ""}
                                    onChange={e => onProvinceChanged(e.target.value)}>
                                    <option value="">انتخاب کنید</option>
                                    {provinceList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                </select>
                            }
                            {errors.ProvinceID && <small className="errors"> انتخاب استان الزامی است</small>}
                        </div>
                        <div className="form-group col-md-2" >
                            <label>شهر</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            {cityList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {cityList && Array.isArray(cityList) &&
                                <select className="form-control" name="CityID" ref={register({ required: true })}
                                    onChange={e => onCityChanged(e.target.value)}
                                    defaultValue={customer?.CityID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {
                                        cityList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)
                                    }
                                </select>}
                            {errors.CityID && <small className="errors"> انتخاب شهر الزامی است</small>}
                        </div>
                        <div className="form-group col-md-2" >
                            <label>منطقه</label>
                            {zoneList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {zoneList && Array.isArray(zoneList) &&
                                <select className="form-control" name="ZoneID" ref={register({})}
                                    defaultValue={customer?.ZoneID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {zoneList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}

                                </select>
                            }
                        </div>
                        <div className="form-group col-md-2" >
                            <label>کد پستی</label>
                            <input type="text" className="form-control" name="PostalCode" ref={register({})} defaultValue={customer?.PostalCode ?? ""} />
                        </div>
                        <div className="form-group col-md-6" >
                            <div><label>نشانی</label><span style={{ color: "red", fontSize: "13px" }}>*</span></div>
                            <input type="text" className="form-control" name="Address"
                                ref={register({ required: true })} defaultValue={customer?.Address ?? ""} />
                            <Button className='btn-input-tiny' onClick={() => dispatch(setMapPop({ show: true }))}><GeoAltFill size={18} /></Button>
                            {errors.Address && <small className="errors"> آدرس را وارد کنید</small>}
                        </div>
                    </Row>
                    <Row className="rowBorder mt-3">
                        <div className="rowTitle">سایر اطلاعات</div>
                        <div className="form-group col-md-2" >
                            <label>رسته شغلی</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.JobList && Array.isArray(baseInfoes.JobList) &&
                                <select className="form-control" name="Job" ref={register({})}
                                    defaultValue={customer?.Job ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.JobList.map((item, i) => <option key={i} value={item.Job}>{item.Job}</option>)}
                                </select>
                            }
                        </div>
                        <div className="form-group col-md-2" >
                            <label>وضعیت مشتری</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.StatusList && Array.isArray(baseInfoes.StatusList) &&
                                <select className="form-control" name="CustomerStatusID" ref={register({})}
                                    defaultValue={customer?.CustomerStatusID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                </select>
                            }
                        </div>
                        <div className="form-group col-md-2" >
                            <label>&nbsp;</label>
                            <div style={{ border: "solid 1px #534082", borderRadius: "3px", padding: ".450rem .75rem", marginTop: "6px" }}>
                                <input type="checkbox" className="form-check-input" name="IsMainCompany" ref={register({})} onChange={e => onMainChecked(e.target.checked)}
                                    defaultChecked={customer?.IsMainCompany} />
                                &nbsp;
                                <label style={{ color: "blue" }}>شـرکت مــادر</label>
                            </div>
                        </div>
                        <div className="form-group col-md-2" >
                            <label>&nbsp;</label>
                            <div style={{ border: "solid 1px #534082", borderRadius: "3px", padding: ".450rem .75rem", marginTop: "6px" }}>
                                <input type="checkbox" className="form-check-input" name="IsBlackListed" ref={register({})}
                                    defaultChecked={customer?.IsBlackListed} />
                                &nbsp;
                                <label style={{ color: "blue" }}>لیسـت سیــاه</label>
                            </div>
                        </div>
                        <div className="form-group col-md-1" >
                            <label>کد اکتیو</label>
                            <input type="text" className="form-control" name="ActiveCodeInMainCo" disabled={isMainCoChecked !== null ? !isMainCoChecked : !customer?.IsMainCompany} ref={register({})}
                                defaultValue={customer?.ActiveCodeInMainCo ?? ""} />
                        </div>
                        <div className="form-group col-md-1" >
                            <label>کد نمایندگی</label>
                            <input type="text" className="form-control" name="StaffCodeInMainCo" disabled={isMainCoChecked !== null ? !isMainCoChecked : !customer?.IsMainCompany} ref={register({})}
                                defaultValue={customer?.StaffCodeInMainCo ?? ""} />
                        </div>
                        <div className="form-group col-md-2" >
                            <label>نام نمایندگی</label>
                            <input type="hidden" name="AgencyID" ref={register({})} readOnly value={selectedAgency ? selectedAgency.ID : customer && customer.AgencyID ? customer.AgencyID : ""} />
                            <input type="text" className="form-control" readOnly
                                value={selectedAgency ? selectedAgency.LastName : customer?.AgentName ?? ""} />
                            <Button className="btn-input-tiny" onClick={showSelectStaff}><List size={18} /></Button>
                        </div>
                        <div className="form-group col-md-2" >
                            <label>نام معرف</label>
                            <input type="hidden" name="MiddleManID" ref={register({})} readOnly value={selectedMiddleman ? selectedMiddleman.ID : customer?.MiddleManID ?? ""} />
                            <input type="text" className="form-control" readOnly
                                value={selectedMiddleman ? selectedMiddleman.LastName : customer?.MiddlemanName ?? ""} />
                            <Button className="btn-input-tiny" onClick={showMiddlemanPop}><List size={18} /></Button>
                        </div>
                        <div className="form-group col-md-2" >
                            <label>کمپین فروش</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.CampaignList && Array.isArray(baseInfoes.CampaignList) &&
                                <select className="form-control" name="CampaignID" ref={register({})}
                                    defaultValue={customer?.CampaignID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.CampaignList.map((item, i) => <option key={i} value={item.Item1}>{item.Item2}</option>)}
                                </select>
                            }
                        </div>
                        <div className="form-group col-md-3" >
                            <label>توضیحات</label>
                            <input type="text" className="form-control" name="Description" ref={register({})}
                                defaultValue={customer?.Description ?? ""} />
                        </div>
                        <div className="form-group col-md-3" >
                            <label>متن اختصاصی پیامک تبریک تولد</label>
                            <input type="text" className="form-control" name="HappyBirthdaySMSBody" ref={register({})}
                                defaultValue={customer?.HappyBirthdaySMSBody ?? ""} />
                        </div>
                        <div className="col-md-1 form-group">
                            <label>تاریخ تولد:</label>
                            <DatePicker name="BirthDate" isGregorian={false} timePicker={false} className="form-control" value={birthDate !== null ? momentJalali(birthDate) : null}
                                onChange={value => { setBirthDate(value.local("en").format("YYYY/MM/DD")) }} />
                        </div>
                        {
                            extSettings && Array.isArray(extSettings) &&
                            extSettings.map((item, i) =>
                                <FormGroup key={i} className="col-md-3">
                                    <label>{item.SettingValue}</label>
                                    <Form.Control name={item.SettingName.replace("Customer_", "").replace("_Title", "")}
                                        ref={register({})}
                                        defaultValue={customer ? customer[item.SettingName.replace("Customer_", "").replace("_Title", "")] : ""} />
                                </FormGroup>)
                        }
                    </Row>
                    {Number(id) > 0 &&
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <label style={{ color: "blue", fontWeight: "bold" }}>بخش های مرتبط</label>
                                &nbsp;
                                <PlusSquare size={19} color="#086679" style={{ cursor: "pointer" }} onClick={e => setShowAddSection(true)} />
                                <hr style={{ color: "red", height: "2px", marginTop: "2px", marginBottom: "0" }} />
                                {showAddSection &&
                                    <div className="row" style={{ paddingRight: "10px" }}>
                                        <div className="col-md-3 form-group" style={{ padding: "3px" }}>
                                            <input className="form-control tableRowInput" placeholder="سمت"
                                                onChange={e => sectionData.current.SectionName = e.target.value} />
                                            {sectionError.SectionName && <small className="errors">سمت الزامی است</small>}
                                        </div>
                                        <div className="col-md-2 form-group" style={{ padding: "3px" }}>
                                            <input className=" form-control tableRowInput" placeholder="نام شخص"
                                                onChange={e => sectionData.current.SectionResponsible = e.target.value} />
                                            {sectionError.Responsible && <small className="errors">نام شخص الزامی است</small>}
                                        </div>
                                        <div className="col-md-2 form-group" style={{ padding: "3px" }}>
                                            <input className=" form-control tableRowInput" placeholder=" شماره همراه"
                                                onChange={e => sectionData.current.SectionMobile = e.target.value} />
                                        </div>
                                        <div className="col-md-2 form-group" style={{ padding: "3px" }}>
                                            <input className=" form-control tableRowInput" placeholder="تلفن بخش"
                                                onChange={e => sectionData.current.SectionPhone = e.target.value} />
                                        </div>
                                        <div className="col-md-1 form-group" style={{ padding: "3px" }}>
                                            <input className=" form-control tableRowInput" placeholder="داخلی"
                                                onChange={e => sectionData.current.SectionInternalNumber = e.target.value} />
                                        </div>
                                        <div className="col-md-2  form-group" style={{ marginTop: "18px" }}>
                                            <Button className="group-Btn-smalll" variant="success" onClick={addNewSection}><Check2 size={17} /></Button>
                                            <Button className="group-Btn-smalll" variant="danger" onClick={e => setShowAddSection(false)}> <DashCircle size={17} /></Button>
                                        </div>
                                    </div>
                                }
                                <Table className="fixedTable scrolledTable mt-1" responsive>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "20%" }} >سمت</th>
                                            <th style={{ width: "20%" }}>نام شخص</th>
                                            <th style={{ width: "20%" }}>شماره همراه </th>
                                            <th style={{ width: "20%" }}>تلفن بخش</th>
                                            <th style={{ width: "13%" }}>داخلی</th>
                                            <th style={{ width: "7%" }}>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {relatedSections === "PENDING" &&
                                            <tr>
                                                <td colSpan={5}>
                                                    <Loader type="BallTriangle" color="#eebb1370" />
                                                </td>
                                            </tr>
                                        }
                                        {
                                            relatedSections && Array.isArray(relatedSections) &&
                                            relatedSections.map((item, i) =>
                                                <tr key={i} className="resultTableRow">
                                                    <td style={{ width: "20%" }}>{!item.SectionName || item.SectionName === "" ? "--" : item.SectionName}</td>
                                                    <td style={{ width: "20%" }}>{item.SectionResponsible}</td>
                                                    <td style={{ width: "20%" }}>{(item.SectionMobile ?? "") === "" ? "--" : item.SectionMobile}</td>
                                                    <td style={{ width: "20%" }}>{(item.SectionPhone ?? "") === "" ? "--" : item.SectionPhone}</td>
                                                    <td style={{ width: "13%" }}>{!item.SectionInternalNumber || item.SectionInternalNumber === "" ? "--" : item.SectionInternalNumber}</td>
                                                    <td style={{ width: "7%" }}><Trash color="red" size={15} className="rowBtn" onClick={() => deleteSection(item.ID)} /></td>
                                                </tr>)
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    }
                    <div className="mt-2" style={{ position: "sticky", bottom: "10px", zIndex: 50 }}>
                        <Button variant="success" type="submit" className="group-Btn-large" disabled={isPending}>
                            {isPending ? <Loader type="BallTriangle" color="white" height={20} width={20} /> :
                                (Number(id) > 0 ? <Fragment><Pencil size={16} /> ویرایش اطلاعات</Fragment> : <Fragment><CheckLg size={17} /> ثبت اطلاعات</Fragment>)}
                        </Button>
                        {isMobileApp() && Number(id) > 0 && <Button className="btn-violet group-Btn" onClick={e => showMenu(e)}><List size={17} />
                        </Button>}
                        {isWebApp() && Number(id) > 0 &&
                            <Fragment>
                                <Button className="btn-violet group-Btn-large" onClick={showComplaint}><EmojiAngry size={17} />&nbsp; ثبت شکایت</Button>
                                <Button className="group-Btn-large" onClick={showReminerPop} variant="info"><CalendarDate size={17} />&nbsp; ثبت یادآوری</Button>
                                <Button className="group-Btn-large" onClick={showDocRefer} variant="secondary"><ReplyFill size={17} />&nbsp;ارجاع به کاربر</Button>
                                <Button className="group-Btn-large" onClick={showCommand}><Command size={17} />&nbsp;دستور کار</Button>
                                <Button className="group-Btn-large" onClick={showModalNotice} variant="warning"><CardText size={17} />&nbsp;صدور اطلاعیه</Button>
                                <Button className="group-Btn-large" onClick={gotoAccReport}><BookHalf size={17} />&nbsp;مشاهده حساب</Button>
                            </Fragment>}
                    </div>
                </form>
            }
        </Fragment >
    )
}
export default CustomerInfo;